import createTable from './CompanyDetailsTable';

export default createTable({
  namePrefix: 'targetCustomers',
  tableName: 'Customers',
  columns: [{ field: 'customer' }, { field: 'percent', title: '%', className: 'text-right', type: 'number' }],
});
